import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, Transition as _Transition, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3396ab98"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "mb-md" }
const _hoisted_2 = ["innerHTML"]
const _hoisted_3 = { class: "w-full flex flex-row flex-nowrap" }
const _hoisted_4 = { class: "ml-auto mr-md" }
const _hoisted_5 = { class: "mr-auto" }
const _hoisted_6 = {
  key: 0,
  class: "mt-md max-w-500 mx-auto"
}

import { useBlockLabels } from '@/shared/content/blocks/helpers/block-labels.plugin';
import utilitiesService from '@/shared/utilities.service';
import siteContextService from '@/b2c/shared/site-context.service';
import {
    BoliaMoney,
    Deliverable,
    LabelWithNamedArguments,
    B2CClientService,
} from '@/b2c/shared/api/server-apis';
import { useForm } from 'vee-validate';
import { computed, ComputedRef, onMounted, ref, Ref, watch } from 'vue';
import useBasket from '../../useBasket';
import BlockLabelWithNamedArguments from '@/shared/BlockLabelWithNamedArguments.vue';
import ConfirmationButton from '@/shared/form/ConfirmationButton.vue';
import { useCustomerDeliveryMessages } from '@/b2c/basket/useCustomerDeliveryMessages';
import { forEach } from 'lodash';
import { useDeliverables } from '@/b2c/basket/useDeliverables';
import InputErrorMessage from '@/shared/form/InputErrorMessage.vue';
import CheckoutSkeletonLine from '@/b2c/shared/checkout/ui/CheckoutSkeletonLine.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'CustomerDelivery',
  props: {
    deliverable: null
  },
  setup(__props: any) {

const props = __props as {
    deliverable: Deliverable;
};



const { basketId } = useBasket();
const { setMessages } = useCustomerDeliveryMessages();
const labels = useBlockLabels();
const label: Ref<LabelWithNamedArguments | undefined> = ref(undefined);
const { quantities, customerDeliveryPostalCode, customerDeliveryFreightPrice } = useDeliverables();

const postalCodeValidationRegEx = computed<string>(() => siteContextService.country.postalCodeRegex);

const validationSchema = computed(() => {
    return {
        postalCode: {
            required: true,
            max: 100,
            postalCode: postalCodeValidationRegEx.value,
        },
    };
});

const { handleSubmit, isSubmitting, values } = useForm({
    validationSchema,
});

const showDeliveryInformationSkeleton = ref<boolean>(false);

onMounted(() => {
    values.postalCode = customerDeliveryPostalCode.value;
    if (values.postalCode) {
        showDeliveryInformationSkeleton.value = true;
        setDeliveryInformation(values.postalCode);
    };
});

const deliverableQuantities: ComputedRef<number> = computed(() => {
    return quantities(props.deliverable.items);
});

const blockLabelAnimationKey: ComputedRef<string> = computed(() => {
    let key = '';
    if (label.value) {
        forEach(label.value.namedParams, p => key += p);
    }

    return key;
});

watch(deliverableQuantities, newQuantities => {
    if (values.postalCode && label.value) {
        setDeliveryInformation(values.postalCode);
    };
});

const setDeliveryInformation = async(postalCode) => {
    const response = await B2CClientService
        .getEarliestDeliverDateForBasket(basketId.value, postalCode)
        .then(utilitiesService.unwrapModel)
        .finally(() => showDeliveryInformationSkeleton.value = false);
    label.value = response?.text;

    customerDeliveryPostalCode.value = postalCode;
    customerDeliveryFreightPrice.value = response?.freightPrice ? response.freightPrice : {} as BoliaMoney;

    if (response?.itemMessages) {
        setMessages(response.itemMessages);
    };
};

const submit = handleSubmit(async(form): Promise<void> => {
    return setDeliveryInformation(form.postalCode);
});

return (_ctx: any,_cache: any) => {
  const _component_InputText = _resolveComponent("InputText")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("span", {
        innerHTML: _unref(labels).customerDeliveryInfoTitle
      }, null, 8, _hoisted_2)
    ]),
    _createElementVNode("form", {
      autocomplete: "off",
      novalidate: "",
      onSubmit: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_unref(submit) && _unref(submit)(...args)))
    }, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_InputText, {
            name: "postalCode",
            label: _unref(labels).customerDeliveryPostalCode,
            "show-errors": false,
            class: "text-left padding-b"
          }, null, 8, ["label"]),
          _createVNode(InputErrorMessage, {
            name: "postalCode",
            class: "mt-3 absolute"
          })
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(ConfirmationButton, {
            class: "c-button--outline u-valign-inline-button min-w-320",
            confirm: _unref(isSubmitting),
            text: _unref(labels).customerDeliveryCalculateTimeAndPrice,
            "confirmation-text": _unref(labels).customerDeliveryButtonLoadingText
          }, null, 8, ["confirm", "text", "confirmation-text"])
        ])
      ])
    ], 32),
    _createVNode(_Transition, {
      name: "o-anim-fade-300",
      mode: "out-in",
      appear: ""
    }, {
      default: _withCtx(() => [
        (showDeliveryInformationSkeleton.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              _createVNode(CheckoutSkeletonLine, {
                dark: true,
                class: "mb-8"
              }),
              _createVNode(CheckoutSkeletonLine, { dark: true })
            ]))
          : (label.value)
            ? (_openBlock(), _createBlock(BlockLabelWithNamedArguments, {
                key: _unref(blockLabelAnimationKey),
                label: label.value,
                class: "mt-md"
              }, null, 8, ["label"]))
            : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
}
}

})